import { EsDocument } from "@edp-models/ES/es-document.model";

export interface IDocumentEs {
    document: EsDocument[];
}

export const initialDocumentState = {
    document: null,
};

export const initialDocumentEsState: IDocumentEs = {
    ...initialDocumentState,
};
